interface KpiCardProps {
  icon: string;
  label: string;
  value: string;
  note?: string;
  noteTone?: "green" | "red" | "gray" | "teal";
  valueTone?: "default" | "teal" | "green";
}

const valueColors: Record<string, string> = {
  default: "text-ghasla-text-heading",
  teal: "text-[#00AAB7]",
  green: "text-[#27AE60]",
};

const noteColors: Record<string, string> = {
  green: "text-[#27AE60]",
  red: "text-[#E74C3C]",
  teal: "text-[#00AAB7]",
  gray: "text-ghasla-text-secondary",
};

export default function KpiCard({
  icon,
  label,
  value,
  note,
  noteTone = "gray",
  valueTone = "default",
}: KpiCardProps) {
  return (
    <div className="rounded-2xl bg-white p-5 shadow-card transition-shadow hover:shadow-md">
      <div className="flex items-start justify-between gap-3">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#E6F7F8] text-[#0D6E6E]">
          <i className={`${icon} text-xl`} />
        </span>
        <span className="text-[13px] leading-5 text-ghasla-text-secondary">{label}</span>
      </div>
      <p className={`mt-4 whitespace-nowrap text-[30px] font-bold leading-none md:text-[36px] ${valueColors[valueTone]}`}>
        {value}
      </p>
      {note && <p className={`mt-2.5 text-xs font-medium ${noteColors[noteTone]}`}>{note}</p>}
    </div>
  );
}